export default __webpack_public_path__ + "static/media/nato.397304ac.svg";